import axios, { AxiosInstance } from 'axios';

const API_V1_PREFIX = '/api/v1';

export const normalizeApiBaseUrl = (configuredUrl?: string): string => {
  const fallbackUrl = 'http://localhost:8000/api/v1';
  const rawUrl = (configuredUrl || fallbackUrl).trim().replace(/\/+$/, '');
  return rawUrl.replace(/\/api\/v1$/i, '');
};

const BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);

// Create axios instance with default config. Endpoints below include the API
// version prefix so deployments cannot accidentally produce /api/v1/api/v1.
const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Types
export interface PredictionRequest {
  answers: number[];
  studentId?: number;
  studentName?: string;
  studentEmail?: string;
  centerId?: number;
  directorId?: number;
}

export interface PredictionResponse {
  enneagram_type: number;
  wing: number;
  type_probabilities: number[];
  wing_probabilities: number[];
  session_id?: string;
}

export interface Question {
  id: number;
  text: string;
  category: string;
  original_id: string;
}

export interface QuestionsResponse {
  questions: Question[];
  total: number;
}

// API methods
export const apiService = {
  // Get all questions
  getQuestions: async (): Promise<Question[]> => {
    const response = await api.get<QuestionsResponse>(`${API_V1_PREFIX}/questions`);
    return response.data.questions;
  },

  // Submit test answers and get prediction
  submitAnswers: async (
    answers: number[],
    studentData?: {
      studentId?: number;
      studentName?: string;
      studentEmail?: string;
      centerId?: number;
      directorId?: number;
    }
  ): Promise<PredictionResponse> => {
    const payload: PredictionRequest = { answers, ...studentData };
    const response = await api.post<PredictionResponse>(`${API_V1_PREFIX}/predict`, payload);
    return response.data;
  },
};
